import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_B2B_BIZ_USER, IS_CORP_USER, IS_ONPREMISE, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';

export const hideCleanerInMenu = !IS_PAID_USER && !IS_CORP_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER && isFeature('hide-cleaner-in-space');
